import React, { useEffect, useState } from "react";

import PageHeader from "../components/PageHeader";
import Section from "../components/Section";
import { api } from "../services/api";

const ClientConditions = ({ activeLang }) => {
  const [conditions, setConditions] = useState("");

  useEffect(() => {
    const getGeneralConditions = async () => {
      const response = await api.get("/general-conditions");
      setConditions(
        activeLang === "en"
          ? response.data.english_text
          : response.data.spanish_text || response.data.english_text
      );
    };
    getGeneralConditions();
  }, [activeLang]);

  return (
    <React.Fragment>
      <PageHeader
        titleKey="Del Rules"
        image="images/papegaai.jpg"
        bgPos="0% 50%"
        activeLang={activeLang}
      />
      <Section extraClasses="content-width center p-top__large p-bottom__x-large mobile-p-left__large mobile-p-right__large">
        <div
          className="line-height__large"
          dangerouslySetInnerHTML={{ __html: conditions }}
        ></div>
      </Section>
    </React.Fragment>
  );
};

export default ClientConditions;
